module.exports = __webpack_public_path__ + "fonts/DrukCond-Super-Trial.377f8ed.otf";